import { createSlice } from '@reduxjs/toolkit';

export const initialSharedState = {
  attribute_image_rules: [],
};

export const sharedSlice = createSlice({
  name: 'shared',
  initialState: initialSharedState,
  reducers: {},
});

export default sharedSlice.reducer;

export const sharedSelector = (state) => state.shared;
export const attributeImageRulesSelector = (state) => state.shared.attribute_image_rules;
